
import { mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { getLiveClickIds } from '@/utils/clickIds';


export default {
  name: 'WebinarForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
   props: {
    title: {
      type: String,
      default: '',
    },    
    blurb: {
      type: String,
      default: '',
    },    
    date: {
      type: String,
      default: '',
    },    
    time: {
      type: String,
      default: '',
    },    
    url: {
      type: String,
      default: '',
    },
    datetime: {
      type: String,
      default: '',
    },
    image_url: {
      type: String,
      default: '',
    }
 },
  data() {
    return {
      a: Math.ceil(Math.random() * 10),
      b: Math.ceil(Math.random() * 10),
      showError: false,
      answer: null,
      form: {},
      messageSent: false,
      merge_vars: {},
      loading:false
    }
  },
  computed: {
    ...mapGetters({
      userId: 'user/id',
    }),
    bottest() {
      return `What is ${this.a} + ${this.b} ?`
    },
    c() {
      return parseInt(this.a + this.b)
    },

  },
  methods: {
    async Submit() {

      this.loading = true
      console.log(this.form)
      const userId = this.userId
      const teflID = new URLSearchParams(window.location.search).get(
        "teflid"
      );

      const dataToSend = {
        email: this.form.email, 
        campaign: this.$props.title || 'Webinar coming soon', 
        merge_vars: this.merge_vars, 
        props: this.$props
        // ...(this.userId !== "" ? {id:userId}: {}), 
      }

      if(teflID) { // check if teflid parameter is set to anything
        dataToSend.referrer = teflID
      } else {
          const teflID2 = localStorage.getItem('tefl_teflid');
          if(teflID2) { // check if teflid parameter is set to anything
            dataToSend.referrer = teflID2
          }
      }

        // CLICK IDS — every live one, from the shared util. Listing them here
        // individually is how msclkid came to be captured, stored and never sent.
        const ids = getLiveClickIds();
        Object.assign(dataToSend, ids);
        dataToSend.click_ids = ids;

      // TOUCHPOINTS — capture the journey at lead creation time
      try {
        const touchpoints = JSON.parse(localStorage.getItem('tefl_touchpoints'));
        if (touchpoints && touchpoints.length) dataToSend.touchpoints = touchpoints;
      } catch (e) {
        console.warn('Could not parse touchpoints from localStorage');
      }


      console.log('Submit the form')
      this.loading = true
      const result = await this.$axios
      .$post(
        `${process.env.DATA_URL}/klaviyo/automations/webinar/send`,
            dataToSend
        )
        .catch((error) => {
          console.log('Error', error)
        })

        // result = JSON.parse(result.slice(9))

      if (result.statusCode === 204) {
        
        if ( window ) {

          // Identify via plugin
          this.$rs.identify(this.form.email, {
            ...(this.userId !== "" ? {userId}: {}),
            name: this.merge_vars.FNAME + ' ' + this.merge_vars.LNAME,
            email: this.form.email,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via rudderstack
          this.$rs.track("Generate Lead", {
            form_name: 'Webinar - '+this.$props.title,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via GTM
          this.$gtm.push({
            event: 'generate_lead',
            form_name: 'Webinar - '+this.$props.title,
            enhanced_conversion_data: {
                "email": this.form.email
            },
            user_data: {
              "email": this.form.email
            }
          });
          
        }
        console.log('emit success')
        this.$emit("success")
        this.messageSent = true

      }


    },
  },
}
